import Playground from 'components/Playground';
import Jumbotron from "components/Jumbotron";
import * as React from 'react';
export default {
  Playground,
  Jumbotron,
  React
};